/**
 * Utility functions for file operations
 */

/**
 * Converts a File object to base64 string
 * @param file - The file to convert
 * @returns Promise<string> - The base64 content without the data URL prefix
 */
export const convertFileToBase64 = (file: File): Promise<string> => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => {
			const result = reader.result as string;
			// Remove the data URL prefix to get just the base64 content
			const base64 = result.split(",")[1];
			resolve(base64);
		};
		reader.onerror = () => reject(new Error("Failed to read file"));
	});
};
